import { ChangeEvent, useState } from 'react';
import styled from 'styled-components';
import { bouTextFontStyle, getTextStyle } from '../../../content/texts/bou-text/text-style';
import { BouColor } from '../../../global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../../layout/bou-spacing';
import { fluidSpaceLg } from '../../../utilities/fluid/fluid';
import { StyledLabel } from '../bou-text-input-facade';

export interface Props {
  value: string | undefined;
  placeholder: string;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  label?: string;
  className?: string;
  invalid?: boolean;
  invalidText?: string; // Pass an empty string to not show the text at all
  onFocus?: () => void;
  onBlur?: () => void;
  validateOnBlur?: boolean;
}

export const BouTextAreaInput = (props: Props) => {
  const [blurred, setBlurred] = useState(false);
  const value = props.value || '';
  const showInvalid = !!props.invalid && (props.validateOnBlur ? blurred : true);
  const invalidText = props.invalidText !== undefined ? props.invalidText : 'This field is required!';

  return (
    <Root className={props.className}>
      {props.label && <StyledLabel>{props.label}</StyledLabel>}
      <StyledInput
        value={value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        invalid={showInvalid}
        onFocus={props.onFocus}
        onBlur={() => {
          props.onBlur;
          setBlurred(true);
        }}
      />
      {showInvalid && <InvalidText>{invalidText}</InvalidText>}
    </Root>
  );
};

const Root = styled.div`
  ${bouTextFontStyle};
  & + & {
    ${fluidSpaceLg('margin-top', 10)}
  }
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const StyledInput = styled.textarea<{ invalid?: boolean }>`
  border: 1px solid ${props => (!props.invalid ? 'rgba(0, 0, 0, 0.15)' : BouColor.TOOL_TEXT_ERROR_RED)};
  ${fluidSpacing('padding', BouSpacingLevel.TINY)};
  flex-grow: 1;
  flex-shrink: 0;
  min-height: 80px;
  color: ${BouColor.BLACK};
  background-color: transparent;
  width: 100%;
  max-width: 100%;
  resize: none;
  &::placeholder {
    color: ${BouColor.DARK_GRAY_ALPHA};
  }
  &:focus {
    outline: none;
    resize: vertical;
  }
`;

const InvalidText = styled.div`
  ${getTextStyle({ size: 'xsmall' })}
  color: ${BouColor.TOOL_TEXT_ERROR_RED};
  font-style: italic;
  margin-top: 0.3em;
`;
